export const iconFontAwesomeHumanitarianPersonHarassing = (
	<i className="fa-solid fa-person-harassing"></i>
);
